<template>
  <b-container>
    <div class="page-tit">仲裁员查询</div>
    <el-row class="toolbar" :gutter="20">
      <el-col :span="7">
        <el-input placeholder="请输入姓名" v-model="arbitratorFindData.arbitratorName"></el-input>
      </el-col>
      <el-col :span="7">
        <el-input placeholder="请输入专长" v-model="arbitratorFindData.condition"></el-input>
      </el-col>
      <el-col :span="8">
        <div class="tool-btns">
          <el-button type="primary" @click="searchArbitrator" plain>查询</el-button>
          <a
            class="el-button el-button--primary is-plain"
            href="/static/docs/仲裁员名册（2018年9月）.pdf"
            download="仲裁员名册（2018年9月）.pdf"
          >
            <i class="el-icon-download" style="position: static;"></i>点击下载：仲裁员名册
          </a>
        </div>
      </el-col>
    </el-row>
    <el-table
      :data="arbitratorData"
      v-loading="arbitratorLoading"
      @row-click="selectRow"
      border
      stripe
      highlight-current-row
      :header-row-style="{background: '#ccc'}"
      style="width: 100%"
    >
      <el-table-column property="userName" label="姓名" width="160"></el-table-column>
      <el-table-column property="speciality" class-name="special" label="专长" show-overflow-tooltip></el-table-column>
      <el-table-column property="city" style="padding-left: 30px;" label="城市" width="90"></el-table-column>
      <el-table-column property="workExp" style="padding-left: 30px;" label="国籍" width="120"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :close-on-click-modal="false"
        @size-change="arbitratorPageSize"
        @current-change="arbitratorPageNo"
        :current-page.sync="arbitratorPageFindData.pageNo"
        :page-sizes="[10, 15, 20, 50, 100]"
        :page-size="arbitratorPageFindData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="arbitratorTotal"
      ></el-pagination>
    </div>
  </b-container>
</template>

<script>
import { queryArbitrator, groupTrail } from "api/party/party";

export default {
  data() {
    return {
      dialogVisible: false,
      arbitratorLoading: true,
      isOnSubmit: false,
      arbitratorData: [],
      arbitratorTotal: 0,
      arbitratorFindData: {
        arbitratorName: "",
        condition: ""
      },
      arbitratorPageFindData: {
        pageNo: 1,
        pageSize: 10
      },
      groupData: {
        userAccount: ""
      }
    };
  },
  methods: {
    submit() {
      var me = this;
      this.isOnSubmit = true;
      this.groupData.caseTempNo = this.$route.query.caseTempNo;
      groupTrail(this.groupData).then(function(res) {
        if (res.type === "success") {
          me.$message({
            type: "success",
            duration: "2000",
            message: "选择成功"
          });
          me.close();
        } else {
          me.$message.error("选择失败，" + res.title);
          me.isOnSubmit = false;
        }
      });
    },
    openSelect() {
      this.queryArbitrator();
      this.dialogVisible = true;
    },
    // 查仲裁员
    arbitratorPageNo(val) {
      this.arbitratorPageFindData.pageNo = val;
      this.queryArbitrator(this.arbitratorPageFindData);
    },
    arbitratorPageSize(val) {
      this.arbitratorPageFindData.pageSize = val;
      this.queryArbitrator(this.arbitratorPageFindData);
    },
    searchArbitrator() {
      this.arbitratorPageFindData = {
        ...this.arbitratorPageFindData,
        ...this.arbitratorFindData
      };
      this.queryArbitrator(this.arbitratorFindData);
      this.arbitratorPageFindData.pageNo = 1;
    },
    queryArbitrator(data) {
      var me = this;
      me.arbitratorLoading = true;
      queryArbitrator(data)
        .then(function(res) {
          console.log(res);
          me.arbitratorData = res.data;
          me.arbitratorTotal = res.recordCount;
          me.arbitratorLoading = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    close() {
      this.dialogVisible = false;
      this.groupData.userAccount = "";
    },
    selectRow(row, e) {
      this.groupData.userAccount = row.userAccount;
    }
  },
  created() {
    this.queryArbitrator();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 20px;
  padding-bottom: 20px;
}
.page-tit {
  padding-bottom: 8px;
  margin-bottom: 18px;
  border-bottom: 1px dotted #00a0e9;
}
.toolbar {
  margin-bottom: 15px;
}
.pagination {
  margin-top: 10px;
  justify-content: flex-end;
}
.el-pagination {
  width: 100%;
  text-align: right;
}
.hint {
  position: relative;
  top: -14px;
  left: 4px;
}
</style>
<style>
.special .cell {
  white-space: nowrap;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/home/search/search.vue